/* @ngInject */
export default function L4ModalController($scope, close) {
  $scope.close = close;
}
